import { subscribeChannel, publishChannel } from './channelUtils';

export function sendVehicles(veiculos) {
    
    publishChannel('veiculos-sync', veiculos);

}

export function sendVehicleUpsert(veiculo) {
    
    publishChannel('veiculo-upsert', veiculo);

}

export function sendVehicleRemove(veiculoId) {
    
    publishChannel('veiculo-remove', veiculoId);

}

export function sendVehiclesTrip(trips) {

    publishChannel('veiculos-trip', trips);

}

export function sendVehiclesSelectedTrips(veiculosEmViagemSelecionados) {

    publishChannel('veiculos-trip-selected', veiculosEmViagemSelecionados);

}

export function listenVehicles(callback) {

    return subscribeChannel((event) => {

        const { tipo, payload } = event.data;

        if (
            tipo !== 'veiculos-sync' &&
            tipo !== 'veiculo-upsert' &&
            tipo !== 'veiculo-remove' &&
            tipo !== 'veiculos-trip' &&
            tipo !== 'veiculos-trip-selected'
        ) {
            return;
        }

        callback({ tipo, payload });

    });

}